<template>
  <div class="index">
    <Header></Header>
    <div class="wrap-block">
      <Banner></Banner>
      <IndexService></IndexService>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Banner from '@/components/Banner';
import IndexService from '@/components/IndexService.vue';

export default {
  name: "Index",
  components: {
    Header,
    Footer,
    Banner,
    IndexService
  }
}
</script>

<style lang="less" scoped>
.index {
  background: var(--bg-primary);
  min-height: 100vh;
  position: relative;
}

.wrap-block {
  position: relative;
  padding-top: 0;
  background: var(--bg-primary);
  overflow: hidden;
}
</style>
